import { render, staticRenderFns } from "./QuestionNoteContent.vue?vue&type=template&id=4f8fa4c8&scoped=true&"
import script from "@/scripts/Notes/NoteDetail/components/QuestionNoteContent.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NoteDetail/components/QuestionNoteContent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fa4c8",
  null
  
)

export default component.exports